import Prepare from './Prepare'
import Create from './Create'
import IMtokenTip from './IMtokenTip'
import IMToken from './IMToken'

export {
  Prepare, // 提示去创建钱包
  Create,  // 创建钱包
  IMtokenTip, // 助记词 注意事项
  IMToken  // 助记词
}